import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import swal from 'sweetalert';

const InfoCard = ({ image, title, subtitle, description, url }) => {
    var shortDescription = description;
    var isShort = false;
    if (description.length > 150) {
        shortDescription = description.substring(0, 150) + ' ... ';
        isShort = true;
    }

	function handleComingSoon(text){
		
        swal("Info", text+" Coming Soon.", "info");
	}

    return (
        <div>
            <div className="horizontal-container justify-left gap-lg-md">
                <span className="">
                    <img src={image} alt={title} className="" width="50" />
                </span>
                <span className="">
                    <div className="font-orbitron font-size-20l-18m-16s font-weight-800 letter-spacing-0px uppercase italic">{title}</div>
                    <div className="font-poppins font-size-18l-16m font-weight-600 pt-10">{subtitle}</div>
                </span>
            </div>
            <div className="font-poppins font-size-18l-16m font-weight-400 justify line-height-120per pt-10">
                {shortDescription}
                {isShort && (
                    <Link onClick={() => handleComingSoon(title)}>Read More</Link>
                )}
            </div>
        </div>
    );
};

export default InfoCard;

/*
<div className="info-card">
<img src={image} alt={title} className="info-card-image" width="100"/>
<div className="info-card-text">
<div className="info-card-title font-orbitron font-size-20l-18m font-weight-800 letter-spacing-0px uppercase italic line-height-110pe">{title}</div>
<div className="info-card-subtitle font-source-sans font-size-20l-18m font-weight-600 justify line-height-120per pt-10">{subtitle}</div>
<div className="info-card-description font-source-sans font-size-20l-18m font-weight-500 justify line-height-120per pt-20l-10s">
    {shortDescription}
    {isShort && (
        <Link to={url}>Read More</Link>
    )}
</div>
</div>
</div>
*/